export const FORM_TYPE = {
  TEXTBOX: 1,
  TEXTAREA: 2,
  CHECKBOX: 3,
  RADIO: 4,
  DROPDOWN: 5,
  DATEPICKER: 6,
  ARRAY_OBJECT: 7,
  SLOT: 8,
  DAY_HOURS_SELECTOR: 9,
  SALARY_RANGE: 10,
  HEADER: 11,
  MULTI_SELECT: 12,
  LABEL: 13,
  MONTH_PICKER: 14,
  SUB_HEADER: 15,
  TIME_PICKER: 16,
  FILE: 17,
  SECTION: 18,
  RATING_GROUP: 19,
  SEPARATOR: 20,
  RADIO_TABLE: 21,
  TEXT_EDITOR: 22,
  LIST_ITEMS: 23,
  CHECKBOX_TABLE: 24,
  LANGUAGE_INPUT: 25,
  BOOKING_SECTION: 26,
  TOTAL_YEARS: 27,
  SIGN_DOCUMENT: 28,
  MULTI_DATEPICKER: 29,
  FILE_WITH_INFO: 30,
  HTML: 31,
  LIST_TEXTBOX: 32,
  COLOR_PICKER: 33,
  CHECKBOX_CONDITION: 34,
  YEAR_PICKER: 35,
  PRODUCT_SELECTION: 36,
  RADIO_ICON: 37,
  RATING: 38,
  CHECKBOX_ICON: 39,
  DATETIME_PICKER: 40,
  HTML_SELECTION: 41,
  EXPRESSION: 42,
  CHECKBOX_ITEM: 43,
  PAYMENT: 44,
  LOGGING: 45,
  PASSWORD: 46,
  PRESET_SECTION: 47,
  TAG_HTML: 48,
  PRESET_FIELDS: 49,
  CROPABLE_FILE: 50,
  CREDIT_PACKAGE_SELECTION: 51,
  LIST_TEXTFIELD_INPUT: 52,
  LIST_TEXTAREA: 53,
  LIST_DATEPICKER: 54,
  STRIPE_SUBSCRIPTION_SELECTION: 55,
  BUILDER_FIELD_SELECTOR: 56,
  COLOR_INPUT: 57,
  STATUS_COLOR_INPUT: 58,
  PLACEMENT_JOB_SELECTION: 59,
  LIST_FILES: 60,
  VIDEO: 61,
  LIST_DATE_TIMES_PICKER: 62,
  DATA: 63, // Attach data in list fields
  EVALUATION: 64,
  RETURNING_APPLICANT_BTN: 65, // Button for returning applicant
  SIGNATURE_FIELD: 66,
  HEADER_SLOT: 67, // Header slot (in case of the actual header is hidden)
  SIGNATURE_PAD: 68,
  LIST_TEXT_EDITOR_MULTI_SELECT: 69,
  LIST_TEXT_BOX_MULTI_SELECT: 70,
  LIST_BUILDER_FIELD_SELECTOR: 71,
  DISPLAY_DATES_DURATION: 72,
  LIST_ITEM_MULTI_SELECT: 73,
  CHECKBOX_GROUP_WITH_DATE_RANGE: 74,
  LIST_TEXT_AREA_MULTI_SELECT: 75,
  LIST_2_TEXT_BOX_MULTI_SELECT: 76,
  MONTHLY_CREDIT_PACKAGE_SELECTION: 77,
  LIST_2_TEXTBOX: 78,
  SECTION_BOUNDERY_SLOT: 79,
  REARRANGE_LIST: 80,
  LIST_2_MULTI_SELECT: 81
};

export const LIST_FIELD_TYPES_NOT_CHECK_COMPLETION = [
  FORM_TYPE.SLOT,
  FORM_TYPE.SECTION,
  FORM_TYPE.BOOKING_SECTION,
  FORM_TYPE.HEADER,
  FORM_TYPE.FILE,
  FORM_TYPE.FILE_WITH_INFO,
  FORM_TYPE.CHECKBOX_CONDITION,
  FORM_TYPE.SIGN_DOCUMENT,
  FORM_TYPE.EVALUATION,
  FORM_TYPE.PRESET_SECTION,
  FORM_TYPE.PAYMENT,
  FORM_TYPE.HTML,
  FORM_TYPE.DATA,
  FORM_TYPE.RETURNING_APPLICANT_BTN,
  FORM_TYPE.SEPARATOR,
  FORM_TYPE.LOGGING,
  FORM_TYPE.LABEL,
  FORM_TYPE.SUB_HEADER,
  FORM_TYPE.CREDIT_PACKAGE_SELECTION,
  FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION,
  FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION,
  FORM_TYPE.DISPLAY_DATES_DURATION,
  FORM_TYPE.EXPRESSION,
]

export const LIST_FIELD_TYPES_HAS_NO_REQUIRED_OPTIONS = [
  FORM_TYPE.SLOT,
  FORM_TYPE.SECTION,
  FORM_TYPE.BOOKING_SECTION,
  FORM_TYPE.HEADER,
  FORM_TYPE.CHECKBOX_CONDITION,
  FORM_TYPE.PRESET_SECTION,
  FORM_TYPE.PAYMENT,
  FORM_TYPE.HTML,
  FORM_TYPE.DATA,
  FORM_TYPE.RETURNING_APPLICANT_BTN,
  FORM_TYPE.SEPARATOR,
  FORM_TYPE.LOGGING,
  FORM_TYPE.LABEL,
  FORM_TYPE.SUB_HEADER,
  FORM_TYPE.DISPLAY_DATES_DURATION,
  FORM_TYPE.EXPRESSION,
]

export const LIST_FIELDS_NO_MODEL = [
  FORM_TYPE.SLOT,
  FORM_TYPE.SECTION,
  FORM_TYPE.BOOKING_SECTION,
  FORM_TYPE.HEADER,
  FORM_TYPE.FILE_WITH_INFO,
  FORM_TYPE.CHECKBOX_CONDITION,
  FORM_TYPE.SIGN_DOCUMENT,
  FORM_TYPE.EVALUATION,
  FORM_TYPE.PRESET_SECTION,
  FORM_TYPE.PAYMENT,
  FORM_TYPE.HTML,
  FORM_TYPE.DATA,
  FORM_TYPE.RETURNING_APPLICANT_BTN,
  FORM_TYPE.SEPARATOR,
  FORM_TYPE.LABEL,
  FORM_TYPE.SUB_HEADER,
  FORM_TYPE.DISPLAY_DATES_DURATION,
  FORM_TYPE.EXPRESSION,
  FORM_TYPE.SECTION_BOUNDERY_SLOT,
  FORM_TYPE.PLACEMENT_JOB_SELECTION
]

export const ACTION_TYPE = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3,
  CANCEL: 4,
  SET_VISIBILITY: 5,
  DELETE_FILE: 6
};

export const TEXTBOX_INPUT_TYPE = {
  TEXT: "TEXT",
  INTEGER: "INTEGER",
  POSITIVE_INTEGER: "POSITIVE_INTEGER",
  POSITIVE_DOUBLE: "POSITIVE_DOUBLE",
  DOUBLE: "DOUBLE"
};

export const SERVICE_TYPES = {
  PLACEMENT: "Placement",
  SITTER: "Sitter"
};

export const FILE_TYPES = {
  DOCUMENT: "Document",
  IMAGE: "Image",
  ALL: "All"
};

export const JOB_TYPES = {
  PLACEMENT: "Placement",
  SHIFT: "Shift"
};

export const BUILDER_USER_TYPE = {
  CANDIDATE: "Candidate",
  CLIENT: "Client",
  UNSPECIFIED: "Unspecified"
};

export const BUILDER_TYPE = {
  APPLICATION: "Application",
  PROFILE: "Profile",
  SECTION: "Section",
  FILE_INFO: "File Information",
  REFERENCE_CHECK: "Reference Check",
  PLACEMENT_JOB: "Placement Job",
  ADD_USER: "Add User",
  SHIFT_JOB_REPORT: "Shift Job Report",
  JOB_APPLICATION_FORM: "Job Application Form",
  SCHEDULE_INTERVIEW_FORM: "Schedule Interview Form",
  REVIEW_USER: "Review User",
  ADMIN_INFORMATION: "Admin Information"
};

export const PROFILE_PICTURE_SCOPE = {
  NONE: "None",
  PRIVATE: "Private",
  PUBLIC: "Public"
};

export const DEFAULT_DOCUMENT_SCOPE = ["Private", "Public"];

export const PRICE_TYPES = {
  REGISTRATION_FEE: "Registration Fee",
  HOURLY_BOOKING_RATE: "Hourly Booking Rate",
  HOURLY_FEE_PER_ADDITIONAL_CHILD: "Hourly Fee Per Additional Child",
  HOURLY_AGENCY_FEE: "Hourly Agency Fee",
  HOURLY_AGENCY_COMMISSION: "Hourly Agency Commission",
  TRAVEL_FEE: "Travel Fee",
  RUSH_FEE: "Rush Fee",
  CANDIDATE_RUSH_FEE: "Candidate Rush Fee",
  RUSH_HOURLY_FEE: "Rush Hourly Fee",
  PER_BOOKING_AGENCY_FEE: "Per Booking Agency Fee",
  PER_BOOKING_CANDIDATE_FEE: "Per Booking Candidate Fee",
  PER_TIME_RANGE_CANDIDATE_FEE: "Per Time Range Candidate Fee",
  HOURLY_SERVICES_SELECTION: "Hourly Service Selection",
  BOOKING_TOTAL_DISCOUNT: "Booking Total Discount",
  ADMIN_FEE: "Admin Fee",
  ADMIN_PERCENTAGE: "Admin Percentage",
  ADDITIONAL_OVERNIGHT_HOURLY_RATE: "Additional Overnight Hourly Rate",
  HOURLY_RATE_FOR_ADDITIONAL_HOURS: "Hourly Rate for Additional Hours"
};

export const JOB_STATUSES = {
  CANCELLED: "Cancelled",
  ASSIGNED: "Assigned"
};

export const DOCUMENT_SECTION_INPUT_DIAGLOG_TYPE = {
  ACCESS_CONTROL: 0,
  UPLOAD_FILE: 1
};

export const INPUT_STATUS = {
  VALID: 0,
  INVALID: 1,
  EMPTY: 2
};

export const STRIPE_PAYMENT_ERROR_IDS = {
  EMPTY: "stripe-payment-error-empty",
  INVALID: "stripe-payment-error-invalid"
};

export const JOB_UPDATE_STATUS_SENT = {
  POSTER: 1,
  FILLER: 2,
  POSTER_FILLER: 3,
  NONE: 0
};

export const PAYMENT_TYPES = {
  STRIPE: "Stripe",
  AUTHORIZE: "Authorize.Net",
  QUICKBOOKS: "Quickbooks",
  SQUARE: "Square"
};


export const DATE_RANGE_DAYS = {
  MY_SCHEDULE_NUM_OF_PAST_DAY: 14,
  MY_SCHEDULE_NUM_OF_FUTURE_DAY: 28,

  MY_JOB_NUM_OF_PAST_DAY: 14,
  MY_JOB_NUM_OF_FUTURE_DAY: 28,
}

export const OPTION_LIST_TYPES = {
  CANDIDATE_LIST_FIELDS: "Candidate List Fields",
  EMPLOYER_LIST_FIELDS: "Client List Fields",
  PLACEMENT_JOB_LIST_FIELDS: "Placement Job List Fields",
  SHIFT_JOB_LIST_FIELDS: "Shift Job List Fields",
  ADMIN_LIST: "Admin List",
  BOOKING_CATEGORIES: "Booking Categories",
  BOOKING_STATUSES: "Booking Statuses",
  CLASS_CATEGORY_LIST: "Class Categories",
  BOOKING_BUILDER_LIST: "Booking Builder List"
}

export const DEFAULT_TYPES = {
  AGENCY_ADMIN_EMAIL_LIST: "Agency Admin Email List",
  AGENCY_FROM_EMAIL_LIST: "Agency From Email List"
}

export const BUTTON_STATUS = {
  NORMAL: "Normal",
  SUBMITTING: "Submitting",
  DONE: "Done"
}

export const BROADCAST_TYPE = {
  SHIFT_JOB: "Shift Job",
  PLACEMENT_JOB: "Placement Job",
  SYSTEM_EVENT: "System Event"
}


// WEBPACK FOOTER //
// ./src/constants/custom-define-type.js